import React from 'react';
import { TruckIcon, ShieldCheckIcon, ClockIcon, StethoscopeIcon } from 'lucide-react';
export function BenefitsBar() {
  const benefits = [{
    icon: <TruckIcon className="w-5 h-5" data-id="element-2142" data-mp="rfcu2pzayrgs" />,
    title: 'Free Delivery',
    description: 'On qualifying orders'
  }, {
    icon: <StethoscopeIcon className="w-5 h-5" data-id="element-2143" data-mp="10akjm3i039ms" />,
    title: 'Licensed Pharmacists',
    description: 'Expert advice available'
  }, {
    icon: <ShieldCheckIcon className="w-5 h-5" data-id="element-2144" data-mp="158vtufc7jm5j" />,
    title: 'Secure Shopping',
    description: 'Safe and verified products'
  }, {
    icon: <ClockIcon className="w-5 h-5" data-id="element-2145" data-mp="1f6s1uy9um0zf" />,
    title: 'Pharmacist Support',
    description: 'Expert advice when you need it'
  }];
  return <div className="hidden border-b border-gray-100 bg-[#f8f9fc] md:block" data-id="element-2146" data-mp="1j83ulco0r2bu">
      <div className="container mx-auto px-4 py-2.5" data-id="element-2147" data-mp="3gzpwmzn6r3n0">
        <div className="grid grid-cols-4 divide-x divide-gray-200" data-id="element-2148" data-mp="3l09xoeavqref">
          {benefits.map((benefit, index) => <div key={index} className="flex items-center gap-3 px-4 first:pl-0 last:pr-0" data-id="element-2149" data-mp="8yu3yihh623l" data-mpi={index}>
              <div className="text-[#1E2B55]" data-id="element-2150" data-mp="47vk58xa2lvl">{benefit.icon}</div>
              <div data-id="element-2151" data-mp="45isu55mqz5v">
                <h3 className="text-sm font-semibold" data-id="element-2152" data-mp="3vdwoyzqngj8s">{benefit.title}</h3>
                <p className="text-xs text-gray-500" data-id="element-2153" data-mp="3vbsm8l4hlqa3">{benefit.description}</p>
              </div>
            </div>)}
        </div>
      </div>
    </div>;
}